export default "__VITE_ASSET__36e758fe__"